import React, { useState } from "react"
import { useMainPatchMutation, useMainRetrieveQuery } from "services/api"
import { toast } from "react-toastify"
import Modal from "react-responsive-modal"
import moment from "moment"

function DeleteUndoButton() {
	const deleteUndo = useMainRetrieveQuery({ action: "getDeleteUndoEvents", tags: ["deleteUndo"] })
	const [patch] = useMainPatchMutation()
	const [open, setOpen] = useState(false)
	const [expanded, setExpanded] = useState({})

	const handleRestore = async (id) => {
		const resp = await patch({
			action: "restoreDeleteBatch",
			id,
			tags: ["entries", "builders", "developers", "deleteUndo"],
		})

		if (resp?.data?.status === 200 && !resp?.data?.message?.includes("not restored")) {
			toast.success(resp?.data?.message || "Delete batch restored.")
			setOpen(false)
		} else {
			toast.error(resp?.data?.message || "Unable to restore delete batch.")
		}
	}

	const detailLabel = (item, record) => {
		if (item.entity_type === "entries") {
			return [
				`ID ${record.id}`,
				record.quarter ? moment.unix(record.quarter).format("[Q]Q YYYY") : null,
				record.sectionName || (record.section ? `Section ${record.section}` : null),
				record.builderName || (record.builder ? `Builder ${record.builder}` : null),
				record.lot_type ? `Lot ${record.lot_type}` : null,
			]
				.filter(Boolean)
				.join(" | ")
		}

		return [
			`ID ${record.id}`,
			record.name,
			record.url,
			record.parent ? `Parent ${record.parent}` : null,
		]
			.filter(Boolean)
			.join(" | ")
	}

	const detailsPreview = (item) => {
		const records = Array.isArray(item.payload) ? item.payload : []
		if (!records.length) return "No record details available."
		return records.slice(0, 3).map((record) => detailLabel(item, record)).join("; ")
	}

	return (
		<>
			<button
				className="btn !bg-gray-500 !text-xs !py-1 !px-3"
				onClick={() => setOpen(true)}
				disabled={!deleteUndo?.data?.length}>
				Recent Deletes ({deleteUndo?.data?.length || 0})
			</button>
			<Modal
				open={open}
				onClose={() => setOpen(false)}
				center
				styles={{ modal: { width: "620px", maxWidth: "94vw" } }}>
				<h2>Recent Deletes</h2>
				<div className="max-h-[70vh] overflow-auto">
					{deleteUndo?.data?.length ? (
						<table className="w-full">
							<thead>
								<tr className="child:text-xs child:text-left child:bg-neutral-200 child:py-2 child:px-2">
									<th>Deleted</th>
									<th>Type</th>
									<th>Name</th>
									<th>Count</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{deleteUndo.data.map((item) => (
									<React.Fragment key={item.id}>
										<tr className="child:text-xs child:py-2 child:px-2 align-top">
											<td>{item.created_at ? moment.unix(item.created_at).format("M/D/YY h:mm A") : ""}</td>
											<td>{item.entity_type}</td>
											<td>{item.entity_name}</td>
											<td>{item.record_count}</td>
											<td className="text-right">
												<button
													type="button"
													className="btn !text-xs !py-1 !px-2"
													onClick={() => handleRestore(item.id)}>
													Restore
												</button>
											</td>
										</tr>
										<tr>
											<td colSpan={5} className="px-2 pb-2">
												<p className="m-0 text-xs">{detailsPreview(item)}</p>
												{Array.isArray(item.payload) && item.payload.length > 3 ? (
													<p className="m-0 text-xs text-neutral-500">+{item.payload.length - 3} more</p>
												) : null}
												{Array.isArray(item.payload) && item.payload.length ? (
													<button
														type="button"
														className="text-primary text-xs font-bold mt-1"
														onClick={() =>
															setExpanded((prev) => ({ ...prev, [item.id]: !prev[item.id] }))
														}>
														{expanded[item.id] ? "Hide Details" : "Show Details"}
													</button>
												) : null}
											</td>
										</tr>
										{expanded[item.id] ? (
											<tr>
												<td colSpan={5} className="bg-neutral-50 px-2 pb-3">
													<div className="max-h-[180px] overflow-auto border border-neutral-200">
														<table className="w-full">
															<tbody>
																{item.payload.map((record) => (
																	<tr key={record.id} className="child:text-xs child:py-1 child:px-2">
																		<td className="w-[80px] font-bold">ID {record.id}</td>
																		<td>{detailLabel(item, record)}</td>
																	</tr>
																))}
															</tbody>
														</table>
													</div>
												</td>
											</tr>
										) : null}
									</React.Fragment>
								))}
							</tbody>
						</table>
					) : (
						<p className="text-sm">No recent deletes available.</p>
					)}
				</div>
			</Modal>
		</>
	)
}

export default DeleteUndoButton
